import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

import useCriteriaSummary from "components/pages/dashboard/surgery_types_procedures/filter/summary/useCriteriaSummary";

const CriteriaSummary = () => {
  const theme = useTheme();
  const { items, isUnrestricted } = useCriteriaSummary();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        py: 1.5,
        my: 3,
        borderRadius: "6px",
        bgcolor: theme.palette.grey[100],
      }}
    >
      <Box
        component="span"
        sx={{
          width: 8,
          height: 8,
          flexShrink: 0,
          borderRadius: "50%",
          bgcolor: isUnrestricted
            ? theme.palette.lightText.main
            : theme.palette.secondary.main,
        }}
      />
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        <Box component="span" sx={{ fontWeight: 600, mr: 1 }}>
          Active Criteria Summary:
        </Box>
        {isUnrestricted ? "None (unrestricted search)" : items.join(", ")}
      </Typography>
    </Box>
  );
};

export default CriteriaSummary;
